import {useMemo} from 'react';
import {useCurrentFrame} from './useCurrentFrame';
import {useDuration} from './useDuration';
import {usePreviewSettings} from './useSettings';

export function usePlayerTime() {
  const {fps} = usePreviewSettings();
  const frame = useCurrentFrame();
  const duration = useDuration();

  return useMemo(
    () => ({
      frame,
      time: frame / fps,
      duration: duration,
      durationTime: duration / fps,
      completion: duration > 0 ? frame / duration : 0,
    }),
    [frame, duration, fps],
  );
}
